import type { ReactNode } from 'react';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { Chip } from '#src/atoms/ui/Chip/index.tsx';

type Props = { amount: number; icon: ReactNode };

export const CurrencyBalance = ({ amount, icon }: Props) => {
  return (
    <Chip size="medium">
      <Horizontal gap={0.5}>
        {icon}
        <LabelM bold>{amount}</LabelM>
      </Horizontal>
    </Chip>
  );
};
